module.exports = __webpack_public_path__ + "img/tv-1024.4f99a0.png";